module.exports = "https://web-assets.ifttt.com/packs/media/icons/rain-snow-dea91f3c.png";